import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import RespondentLogin from './pages/RespondentLogin';
import AdminDashboard from './pages/AdminDashboard';
import Dashboard from './pages/Dashboard';
import CaseFiling from './pages/CaseFiling';
import Cases from './pages/Cases';
import NoticeTemplates from './pages/NoticeTemplates';
import BulkUpload from './pages/BulkUpload';
import CaseRepository from './pages/CaseRepository';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={user ? <Navigate to="/dashboard" /> : <Login setUser={setUser} />} />
        <Route path="/respondent-login" element={user ? <Navigate to="/dashboard" /> : <RespondentLogin setUser={setUser} />} />
        <Route path="/dashboard" element={user ? <Dashboard user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/admin" element={user?.role === 'admin' ? <AdminDashboard user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/case-filing" element={user?.role === 'admin' ? <CaseFiling user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/cases" element={user ? <Cases user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/notice-templates" element={user?.role === 'admin' ? <NoticeTemplates user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/bulk-upload" element={user?.role === 'admin' ? <BulkUpload user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/case-repository/:case_id" element={user ? <CaseRepository user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/" element={<Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
